import { ICompanyInfo } from 'types/carrier'
import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { ENDPOINTS } from 'utils/api/callApi'
import { keymirror } from 'utils/keymirror'

export const CARRIER_INFO_DIALOG_ACTION_TYPES = keymirror({
  OPEN_CARRIER_INFO_DIALOG: undefined,
  CLOSE_CARRIER_INFO_DIALOG: undefined,
})

export const EDIT_CARRIER_INFO_ACTION_TYPE = generateApiActionTypes('EDIT_CARRIER_INFO')

export const COMPANY_INFO_ACTION_TYPE = generateApiActionTypes('COMPANY_INFO')

export const getCompanyInfo = (id: string) => {
  const requestData = {
    endpoint: ENDPOINTS.carriers,
    id,
    group: 'company_info',
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(COMPANY_INFO_ACTION_TYPE),
    },
  }
}

export const openCarrierInformationDialog = () => ({
  type: CARRIER_INFO_DIALOG_ACTION_TYPES.OPEN_CARRIER_INFO_DIALOG,
})

export const closeCarrierInformationDialog = () => ({
  type: CARRIER_INFO_DIALOG_ACTION_TYPES.CLOSE_CARRIER_INFO_DIALOG,
})

export const editCompanyInfo = (id: string, payload: ICompanyInfo) => {
  const requestData = {
    endpoint: ENDPOINTS.carriers,
    id,
    method: 'PUT',
    group: 'company_info',
    body: payload,
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(EDIT_CARRIER_INFO_ACTION_TYPE),
    },
  }
}

export enum ELD_TRACKING_ACTION_TYPES {
  GET_ELD_TRACKING_REQUEST = 'GET_ELD_TRACKING_REQUEST',
  GET_ELD_TRACKING_SUCCESS = 'GET_ELD_TRACKING_SUCCESS',
  GET_ELD_TRACKING_FAILURE = 'GET_ELD_TRACKING_FAILURE',
  UPDATE_ELD_TRACKING_REQUEST = 'UPDATE_ELD_TRACKING_REQUEST',
  UPDATE_ELD_TRACKING_SUCCESS = 'UPDATE_ELD_TRACKING_SUCCESS',
  UPDATE_ELD_TRACKING_FAILURE = 'UPDATE_ELD_TRACKING_FAILURE',
  CLEAR_ELD_TRACKING = 'CLEAR_ELD_TRACKING',
}

const filterActionsByPrefix = (prefix: string) =>
  Object.keys(ELD_TRACKING_ACTION_TYPES).filter((str: string) => str.startsWith(prefix))

interface IEditEldTracking {
  carrierId: string
  isEldApproved: boolean
}

export const editEldTracking = ({ carrierId, isEldApproved }: IEditEldTracking) => {
  const requestData = {
    endpoint: ENDPOINTS.carriers,
    id: carrierId,
    method: 'PUT',
    group: 'eld_tracking_information',
    body: { isEldApproved },
  }

  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: filterActionsByPrefix('UPDATE'),
    },
  }
}

export const checkEldTrackingMethod = (carrierId: string) => {
  const requestData = {
    endpoint: ENDPOINTS.carriers,
    id: carrierId,
    method: 'PUT',
    group: 'eld_tracking_method',
  }

  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: filterActionsByPrefix('GET'), // It's a PUT method but changes aren't being made
    },
  }
}

export const clearEldTracking = () => ({
  type: ELD_TRACKING_ACTION_TYPES.CLEAR_ELD_TRACKING,
})
